require('@/wikaz-konnect/gdi/imports.js')
require('@/wikaz-konnect/adm/imports.js')
require('@/wikaz-konnect/commun/imports.js')
require('@/wikaz-konnect/crm/imports.js')
require('@/wikaz-konnect/gdt/imports.js')
require('@/wikaz-konnect/pdc/imports.js')
require('@/wikaz-konnect/icsilab/imports.js')